import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-art-list",
  "use": "icon-art-list-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-art-list\">\n    <g fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M0 0h20v20H0z\" />\n        <path d=\"M5 4.063h13.125v1.25H5v-1.25Zm0 5.312h13.125v1.25H5v-1.25Zm0 5.313h13.125v1.25H5v-1.25ZM2.812 3.75a.938.938 0 1 1 0 1.875.938.938 0 0 1 0-1.875Zm0 5.313a.938.938 0 1 1 0 1.875.938.938 0 0 1 0-1.876Zm0 5.312a.937.937 0 1 1 0 1.875.937.937 0 0 1 0-1.875Z\" fill=\"rgba(0,0,0,0.6)\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol